import React, {useState} from 'react';
import Icon from '../../../assets/icons/icon';
import moment from 'moment-timezone'
import * as amplitude from "@amplitude/analytics-browser";

function Dials({details, contacts}) {
    const [open, setOpen] = useState(false);
    let calls=0;
    const openUp=()=>{
        setOpen((prevOpen) => !prevOpen);
    }
    function formatToMonthDay(dateString) {
        const formattedDate = moment(dateString).tz('GMT').format('MMMM D, YYYY')
        return formattedDate;
    }

    const sortedDetails = details.slice().sort((a, b) => new Date(a.dialDate) - new Date(b.dialDate));
    calls = sortedDetails.reduce((total, detail) => total + parseInt(detail.callsMade), 0);


    let actualContacts = 0;
    for (const obj of details) {
        if (typeof obj.contacts === "number") {
            actualContacts += obj.contacts;
        }
    }
	/**
	 * @param {PointerEvent} evt
	 */
	const rootClicked = (evt) => {
		evt.stopPropagation();
		try {
			amplitude.track(
				"Expand Section",
				{
					name: "Dials",
				}
			);
		} catch (err) {
			console.error(
				"rootClicked: Exception occurred during Amplitude communication attempt: %s",
				err,
				err,
			);
		}
		openUp();
	}
    // let actualContacts = 0;
    // for (const obj of details) {
    //     if (typeof obj.contacts === "number") {
    //         actualContacts += obj.contacts;
    //     }
    // }
    return (

            <div className="quilityNestedBlockWrapper" onClick={rootClicked}>
                <div className='quilityNestedBlockHeader'>
                    <span className="quilityParentBlockTitle" style={{width: '170px'}}>Dials and Contacts</span>
                    <span style={{marginLeft:'20px'}}>
                        <span className="typeBlock">{details.length} Active Day{details.length > 1 && 's'}</span>
                        <span className="typeBlock">{calls} Calls</span>
                        <span className="typeBlock">{contacts} Contact{contacts > 1 || contacts < 1 ? 's': ''}</span>

                    </span>
                    <span className={`quilityBlockIcon ${!open ? 'rotate':''}`} style={{marginTop: '-5px', transition:'all .5s'}}><span className="fontello"><Icon name={'q-up'} size={20} className="closeIcon" adjust="fontello" /></span></span>
                </div>

                <div className={`detailWrapper ${open ? 'openUp' : ''}`}>
                    {sortedDetails.map((detail, index) => (
                        <div className="detailItem" key={"callback"+index}>
                            <span className="detailDialDate">{formatToMonthDay(detail.dialDate)}</span>
                            <span className="detailDialCount">Dials: {detail.callsMade}</span>
                            <span className="detailDialCount">Contacts: {contacts}</span>
                        </div>
                    ))}
                </div>
            </div>

    );
}

export default Dials;